module.exports = __webpack_public_path__ + "img/slv.a97d271.png";